import { render } from "./AlarmDetail.vue?vue&type=template&id=3602e24b&scoped=true"
import script from "./AlarmDetail.vue?vue&type=script&lang=js"
export * from "./AlarmDetail.vue?vue&type=script&lang=js"

import "./AlarmDetail.vue?vue&type=style&index=0&id=3602e24b&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3602e24b"]])

export default __exports__